// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0185137c","53":"1f92f63d","472":"8ab287e1","528":"f3893293","651":"35c37f5c","710":"916692b9"}[chunkId] + ".chunk.js";
};